import { render, staticRenderFns } from "./noticePersonSelector.vue?vue&type=template&id=0acfef8a&scoped=true&"
import script from "./noticePersonSelector.vue?vue&type=script&lang=js&"
export * from "./noticePersonSelector.vue?vue&type=script&lang=js&"
import style0 from "./noticePersonSelector.vue?vue&type=style&index=0&id=0acfef8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0acfef8a",
  null
  
)

export default component.exports